import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { messages } from '../../../_shared/i18n/messages';

import './PercentageInput.scss';

const propTypes = {

	/**
	 * The input id. If none is provided, the input name is used.
	 */
	id: PropTypes.string,

	/**
	 * The input name.
	 */
	name: PropTypes.string.isRequired,

	/**
	 * The input value.
	 */
	value: PropTypes.string,

	/**
	 * The input placeholder text.
	 */
	placeholder: PropTypes.string,

	/**
	 * True, if editing the input value.
	 */
	isEditing: PropTypes.bool,

	/**
	 * True, if the input value is invalid.
	 */
	isInvalid: PropTypes.bool,

	/**
	 * True, if the input value is disabled.
	 */
	disabled: PropTypes.bool,

	/**
	 * Callback function to handle changes to the input value.
	 */
	onChange: PropTypes.func,

};

const PercentageInput = (props) => {

	const {
		id,
		name,
		value,
		placeholder,
		isEditing,
		isInvalid,
		disabled,
		onChange,
	} = props;

	const parsedValue = parseFloat(value);

	const isFloat = !isNaN(parsedValue);

	if (!isEditing) {

		return (
			<div>
				{isFloat &&
					<FormattedMessage
						{...messages.TC_COMPONENTS_GENERAL_TEXT_PERCENTAGE_WITH_VALUE}
						values={{ value: parsedValue }} />
				}
				{!isFloat &&
					<span className="tc-material-input-display-empty-value">
						<FormattedMessage {...messages.TC_COMPONENTS_FORM_INPUT_TEXT_EMPTY_VALUE} />
					</span>
				}
			</div>
		);

	}

	const handleOnChange = (event) => {

		let parsedNewValue = parseFloat(event.target.value);

		if (isNaN(parsedNewValue)) {

			parsedNewValue = null;

		} else if (parsedNewValue < 0) {

			parsedNewValue = 0;

		} else if (parsedNewValue > 100) {

			parsedNewValue = 100;

		}

		onChange(parsedNewValue);

	};

	return (
		<div
			className={`
				tc-material-input-percentage
				${isInvalid ? 'tc-material-input-wrapper-invalid' : ''}
			`}>
			<input
				id={id || name}
				className={`tc-material-input ${isInvalid ? 'tc-material-input-invalid' : ''}`}
				type="number"
				name={name}
				value={value}
				placeholder={placeholder}
				disabled={disabled}
				onChange={handleOnChange} />
			<span className="tc-material-input-percentage-symbol">
				<FormattedMessage {...messages.TC_COMPONENTS_GENERAL_TEXT_PERCENTAGE_SYMBOL} />
			</span>
		</div>
	);
};

PercentageInput.propTypes = propTypes;

export default PercentageInput;
